<div class="stt">
  <p class="stt__lead">The numbers are saved as contacts and added to the tag you choose, then the message goes out.</p>

  <fieldset class="stt__modes">
    <legend class="bk-sr-only">Where to save the numbers</legend>
    <label class="stt__mode" [class.is-on]="!checked">
      <input type="radio" name="stt-mode" [checked]="!checked" (change)="setMode(false)" />
      <span class="bk-sym stt__mode-icon" aria-hidden="true">sell</span>
      <span class="stt__mode-text">
        <span class="stt__mode-name">Existing tags</span>
        <span class="stt__mode-meta">Add them to tags you already have</span>
      </span>
    </label>
    <label class="stt__mode" [class.is-on]="checked">
      <input type="radio" name="stt-mode" [checked]="checked" (change)="setMode(true)" />
      <span class="bk-sym stt__mode-icon" aria-hidden="true">new_label</span>
      <span class="stt__mode-text">
        <span class="stt__mode-name">A new tag</span>
        <span class="stt__mode-meta">Name a tag for these numbers</span>
      </span>
    </label>
  </fieldset>

  @if (!checked) {
    <div class="stt__existing">
      <div class="stt__existing-head">
        <p class="stt__label">
          @if (selectedTagsCount) {
            {{ selectedTagsCount }} {{ selectedTagsCount === 1 ? "tag" : "tags" }} chosen
          } @else {
            No tags chosen yet
          }
        </p>
        <button type="button" class="bk-btn bk-btn--ghost stt__choose" (click)="openAddTagsModal()">
          <span class="bk-sym" aria-hidden="true">{{ selectedTagsCount ? "edit" : "add" }}</span>
          {{ selectedTagsCount ? "Change tags" : "Choose tags" }}
        </button>
      </div>

      @if (selectedTagsCount) {
        <ul class="stt__tags">
          @for (tag of selectedTags; track $index) {
            <li class="stt__tag">
              <span class="stt__tag-name">{{ tag.name || "Unnamed tag" }}</span>
              <button
                type="button"
                class="stt__remove"
                [attr.aria-label]="'Remove ' + (tag.name || 'tag')"
                (click)="removeTag(tag, $event)"
              >
                <span class="bk-sym" aria-hidden="true">close</span>
              </button>
            </li>
          }
        </ul>
      }
    </div>
  } @else {
    <div class="stt__new" [formGroup]="newTagForm">
      <input-field
        label="Tag name"
        [errorMessage]="
          submitted && newTagForm.controls.name.invalid ? 'Enter a tag name of at least 2 characters.' : ''
        "
      >
        <input class="input-style" formControlName="name" placeholder="For example, October walk-ins" autocomplete="off" />
      </input-field>
      <input-field
        label="Description (optional)"
        [errorMessage]="submitted && newTagForm.controls.description.invalid ? 'Check the description.' : ''"
      >
        <textarea class="input-style stt__desc" formControlName="description" rows="3"></textarea>
      </input-field>
    </div>
  }

  @if (problem) {
    <p class="bk-field__error stt__problem" role="alert">
      <span class="bk-sym" aria-hidden="true">error</span>{{ problem }}
    </p>
  }

  <div class="stt__foot">
    <button type="button" class="bk-btn bk-btn--ghost" (click)="goToPreviousView()">
      <span class="bk-sym" aria-hidden="true">arrow_back</span>
      Back
    </button>
    <button
      type="button"
      class="bk-btn bk-btn--primary"
      [disabled]="loading"
      [attr.aria-busy]="loading"
      (click)="handleSubmit()"
    >
      @if (loading) {
        {{ scheduled ? "Scheduling…" : "Sending…" }}
      } @else {
        {{ scheduled ? "Save and schedule" : "Save and send" }}
      }
    </button>
  </div>

  <!-- Modals -->
  <add-tags-modal
    [open]="showAddTagsModal"
    (close)="closeAddTagsModal()"
    [selection]="selectedTags"
    (updateSelection)="addSelectedTags($event)"
  />
</div>
